import React from 'react';
import './DetailsBody.css';
import male from './male.png';
import female from './female.png';
import { TiLocationOutline } from "react-icons/ti";
import { BsFillFlagFill, BsGenderMale, BsGenderFemale } from "react-icons/bs";
import { GiSoccerBall } from "react-icons/gi";


const DetailsBody = (props) => {
    const { strLeague, intFormedYear, strGender, strCountry, strSport,strDescriptionEN } = props.league;
    // console.log("Details Body:", props.league);

    let playerImg;
    if (strGender === 'Male') {
        playerImg = <img src={male} alt="" className="img-fluid"/>
    }
    else if (strGender === 'Female') {
        playerImg = <img src={female} alt="" className="img-fluid"/>
    }

    let genderIcon;
    if (strGender === 'Male') {
        genderIcon = <BsGenderMale/>
    }
    else if (strGender === 'Female') {
        genderIcon = <BsGenderFemale/>
    }
    
    return (
        <div className="mt-5 details-body">
            <div className="details-card">
                <div className="row">
                    <div className="col-7 p-5 card-info">
                        <h3>{ strLeague }</h3>
                        <h6><TiLocationOutline/>  Founded: { intFormedYear }</h6>
                        <h6><BsFillFlagFill/>  Country: { strCountry }</h6>
                        <h6><GiSoccerBall/>  Sports Type: { strSport }</h6>
                        <h6>{ genderIcon }  Gender: { strGender }</h6>
                    </div>
                    <div className="col-5 player-img">
                        {
                            playerImg
                        }
                    </div>
                </div>
            </div>
            <div className="league-description p-5">
                <p>{strDescriptionEN}</p>
            </div>
        </div>
    );
};

export default DetailsBody;